import Avatar from "./SVG/avatar.svg?react";

const AvatarIcon = () => {
  return <Avatar />;
};

export default AvatarIcon;
